import { defineComponent } from 'vue';
import BaseComponent from './baseFormMixin.jsx';
import utils from '../../../Shared/utils.jsx';
import FormFieldset from './formFieldset.jsx';

export default defineComponent({
    name: 'sform-referenceddocumentschema',
    mixins: [BaseComponent],
    components: {
        FormFieldset
    },
    data: () => ({
        control_schema: null,
        form_all: null,
        watcher$: null
    }),
    props: {
    },
    created() {
        if (this.element.schema) {
            this.watcher$ = this.$watch('element.schema.formatData.DocumentName', () => {
                this.Refresh();
            });
        }
    },
    unmounted() {
        if (this.watcher$) {
            this.watcher$();
            this.watcher$ = null;
        }
    },
    async mounted() {
        await this.loadComplete();
        await this.Refresh();
    },
    computed: {
    },
    methods: {
        async Refresh() {
            if (!this.element.schema) {
                return;
            }

            const doctype = this.element.schema.formatData.DocumentType; // UserControl or UserAction
            const docname = this.element.schema.formatData.DocumentName;

            if (docname) {
                let doc1 = await utils.api.get('Apps/UIWhole/' + doctype + '/' + docname);

                if (!doc1) {
                    doc1 = await utils.api.get('Apps/UIWhole/' + doctype + '/public/' + docname);
                }

                switch (doctype) {
                    case 'UserControl':
                        this.control_schema = doc1.ControlDataSchema;
                        break;
                    case 'Action':
                        this.control_schema = doc1.ActionDataSchema;
                        break;
                    default:
                        this.control_schema = null;
                        this.form_all = null;
                        return;
                }

                if (this.control_schema) {
                    await utils.schema.resolve(this.control_schema);
                    this.form_all = utils.forms.generateFormWithSchema(['*'], this.control_schema);
                }
                else {
                    this.form_all = null;
                }
            }
            else {
                this.control_schema = null;
                this.form_all = null;
            }
        }
    },
    render() {
        if (!this.control_schema || !this.form_all) {
            return null;
        }

        return (
            <FormFieldset
                layouttype="sform-card-layout"
                root={this.root}
                form={this.form_all}
                cmodel={this.itemvalue}
                noinput={this.noinput}
                schema={this.control_schema}
                scopeitems={this.scopeitems}
                controlscope={this.controlscope}
                depth={0}>
            </FormFieldset>
        );
    }
});
